import { render, staticRenderFns } from "./_userNotes.vue?vue&type=template&id=34cf4be2"
import script from "./_userNotes.vue?vue&type=script&lang=js"
export * from "./_userNotes.vue?vue&type=script&lang=js"
import style0 from "./_userNotes.vue?vue&type=style&index=0&id=34cf4be2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports